import { Fragment, useState, useEffect } from "react";
import LoadingLottie from "components/lottieLoading/LoadingLottie";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  useMessageChatBeforeMutation,
  useMessageChatIndexMutateMutation,
  useSendMessageChatIndexMutation,
  useTrackerLocationLiveQuery,
} from "redux/RTQ/IlenkradApi";
import { ToastDanger } from "utils/toast/Toast";
import getUserLocale from "pagesPc/utils/getUserLocale";
import copy from "copy-to-clipboard";
import NotificationFilterPc from "./NotificationFilterPc";
import CustomCommandModal from "utils/TrackerSettingsModal/CustomCommandModal";
import NotificationPc from "pagesPc/Home/notificationPc/NotificationPc";
import { closeChatDrawerOnly } from "redux/drawerSlice/drawerSlice";
const ChatPc = ({ id, closeDrawer }: any) => {
  const chatId: any = id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showInput, setShowInput] = useState<boolean>(false);
  const [messageTxt, setMessageTxt] = useState<string>("");
  const [before_message_id, setBefore_message_id] = useState<any>();
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [dataChatFilter, setDataChatFilter] = useState<any>({});
  const [dataAllChat, setDataAllChat] = useState<any>({});
  const [isCustomCommandModalOpen, setIsCustomCommandModalOpen] =
    useState(false);
  const [isOnline, setIsOnline] = useState(true);
  const [isBackToChats, setIsBackToChats] = useState<boolean>(false);

  const changeShowFilter = () => {
    setShowFilter(!showFilter);
  };
  const getDataChatFilter = (data: any) => {
    setDataChatFilter(data);
  };

  const { data: dataLocation, isSuccess: isSuccessLocation } =
    useTrackerLocationLiveQuery();

  const [
    mutateChat,
    { data: dataChat, isLoading: isLoadingChat, isSuccess: isSuccessChat },
  ] = useMessageChatIndexMutateMutation();

  useEffect(() => {
    if (isSuccessLocation && isSuccessChat) {
      if (dataChat?.chat?.tracker_imei) {
        const imei = dataChat?.chat?.tracker_imei;
        const list = dataLocation?.geo_locations;

        if (list.hasOwnProperty(imei)) {
          setIsOnline(list[imei]?.online);
        }
      }
    }
  }, [dataLocation, isSuccessLocation, isSuccessChat, dataChat]);

  const openCustomCommandModal = () => {
    setIsCustomCommandModalOpen(true);
  };

  const closeCustomCommandModal = () => {
    setIsCustomCommandModalOpen(false);
  };

  const backToChats = () => {
    dispatch(closeChatDrawerOnly());
    setIsBackToChats(true);
  };

  const sendSms = () => {};

  useEffect(() => {
    mutateChat(chatId);
  }, []);

  const hideInput = () => {
    setShowInput(false);
  };

  const showingInput = () => {
    setShowInput(true);
  };

  const handleTxtChange = (txt: string) => {
    setMessageTxt(txt);
  };

  const [
    mutateSendMessage,
    {
      isLoading: isLoadingSendMessage,
      error: erSendMessage,
      isSuccess: isSuccessSendMessage,
    },
  ] = useSendMessageChatIndexMutation();

  const [isRefreshingAfterSend, setIsRefreshingAfterSend] =
    useState<boolean>(false);

  const [
    mutateBeforeMsg,
    { data: dataBeforeMsg, isSuccess: isSuccessBeforeMsg, error: erBeforeMsg },
  ] = useMessageChatBeforeMutation();
  const submitBeforeMsg = () => {
    if (before_message_id !== null && before_message_id !== undefined) {
      const obj = { before_message_id: before_message_id, id: chatId };
      mutateBeforeMsg(obj);
    } else {
      ToastDanger("پیامی برای نمایش وجود ندارد");
    }
  };

  const sendMessage = () => {
    const obj: any = {
      id: chatId,
      message: messageTxt,
    };
    mutateSendMessage(obj);
  };

  useEffect(() => {
    const dataSuccessBeforeMsg: any = dataBeforeMsg;
    if (isSuccessBeforeMsg) {
      setBefore_message_id(dataSuccessBeforeMsg?.first_message_id);
      const newState: any = dataSuccessBeforeMsg?.messages;
      const newStateMsg: any = [...newState].reverse();
      const dataAllChatNew = {
        ...dataAllChat,
        messages: [...dataAllChat?.messages, ...newStateMsg],
      };
      setDataAllChat(dataAllChatNew);
    }
  }, [erBeforeMsg, isSuccessBeforeMsg]);
  const locale = getUserLocale();
  const dateOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };

  useEffect(() => {
    const dataSuccess: any = dataChat;

    if (isSuccessChat) {
      setBefore_message_id(dataSuccess?.first_message_id);
      const dataAllChatNew = {
        ...dataChat,
        messages: [...dataChat?.messages].reverse(),
      };
      setDataAllChat(dataAllChatNew);
    }
  }, [erSendMessage, isSuccessChat]);

  useEffect(() => {
    if (isSuccessSendMessage) {
      const elem = document.getElementsByClassName("chatInput")[0];
      elem.innerHTML = "";
    }
  }, [isSuccessSendMessage]);
  const findIconChat = (type: any) => {
    switch (type) {
      case "command":
        return "icon5-dns";
      case "command_response":
        return "icon5-dns";
      case "admin_support":
        return "icon5-dns";
      case "channel":
        return "icon5-icon5-directions_car";
      case "tracker_alert":
        return "icon5-track_changes";
      case "user_support":
        return "icon5-engineering";

      default:
        return "icon4-share_location";
    }
  };
  const [openBoxMsg, setOpenBoxMsg] = useState<number>(-1);
  const showBoxMsg = (index: number) => {
    setOpenBoxMsg(index);
  };
  const copyText = (txt: string) => {
    return copy(txt);
  };
  const navigateToMap = (imei: any, longitude: any, latitude: any) => {
    closeDrawer();
    navigate("/chat/map", {
      state: {
        imei: imei,
        longitude: longitude,
        latitude: latitude,
      },
    });
  };
  // Continuous refresh - only for support chat
  useEffect(() => {
    if (dataAllChat?.chat?.title === "پشتیبانی") {
      const interval = setInterval(() => {
        setIsRefreshingAfterSend(true);
        mutateChat(chatId).finally(() => setIsRefreshingAfterSend(false));
      }, 10000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [chatId, mutateChat, dataAllChat?.chat?.title]);

  // Enhanced refresh after sending message - only for support chat
  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    let timeout: NodeJS.Timeout | null = null;

    const refresh = () => {
      setIsRefreshingAfterSend(true);
      mutateChat(chatId).finally(() => setIsRefreshingAfterSend(false));
    };

    if (isSuccessSendMessage && dataAllChat?.chat?.title === "پشتیبانی") {
      refresh();
      interval = setInterval(refresh, 5000); // More frequent refresh after sending
      timeout = setTimeout(
        () => {
          if (interval) clearInterval(interval);
        },
        10 * 60 * 1000,
      ) as unknown as NodeJS.Timeout; // Stop enhanced refresh after 10 minutes
    }

    return () => {
      if (interval) clearInterval(interval);
      if (timeout) clearTimeout(timeout);
    };
  }, [isSuccessSendMessage, chatId, mutateChat, dataAllChat?.chat?.title]);

  if (isLoadingChat && !isRefreshingAfterSend) {
    return <LoadingLottie />;
  }
  if (isBackToChats) {
    return <NotificationPc closeDrawer={closeDrawer} />;
  }
  if (dataChatFilter?.messages?.length <= 0 || dataAllChat?.length <= 0) {
    return (
      <>
        <CustomCommandModal
          imei={dataAllChat?.chat?.tracker_imei}
          command={""}
          statusCommand={""}
          sendSms={sendSms}
          onClose={closeCustomCommandModal}
          open={isCustomCommandModalOpen}
          online={isOnline}
        />
        <div className="chatBg">
          <div className="rowCloseDrawerPc">
            <div
              onClick={() => {
                setDataChatFilter({});
                changeShowFilter();
              }}
              className="icon3-close pointer"
            />
          </div>
          <div className="messagesLength">
            <div>در حال حاضر پیامی وجود ندارد</div>
          </div>
        </div>
      </>
    );
  }
  if (showFilter) {
    return (
      <NotificationFilterPc
        getDataChatFilter={getDataChatFilter}
        back={changeShowFilter}
        id={chatId}
        closeDrawer={closeDrawer}
      />
    );
  } else if (dataChatFilter?.messages?.length > 0) {
    return (
      <>
        <CustomCommandModal
          imei={dataAllChat?.chat?.tracker_imei}
          command={""}
          statusCommand={""}
          sendSms={sendSms}
          onClose={closeCustomCommandModal}
          open={isCustomCommandModalOpen}
          online={isOnline}
        />
        <div className="chatBg">
          <div className="rowCloseDrawerPc">
            <div onClick={closeDrawer} className="icon3-close pointer" />
            <div
              onClick={changeShowFilter}
              className="chatHeaderFilter pointer"
            >
              <div>فیلتر کردن پیام ها</div>
              <div className="icon3-filter_alt chatHeaderIcon" />
            </div>
          </div>
          <div className="chatHeader">
            <div onClick={submitBeforeMsg} className="beforeMessage pointer">
              مشاهده پیام های قبل
            </div>
          </div>
          <div className="chatMessageScrollPc scrollbar-div">
            {dataChatFilter?.messages.map((message: any, index: number) => (
              <Fragment key={message.id}>
                {message.message_type === "user_support" ? (
                  <div className="messageContainer">
                    <div className="messageIconContainerPc">
                      <div
                        className={`${findIconChat(
                          message.message_type,
                        )} chatItemIconsPc`}
                      />
                    </div>
                    <div className="myMessageContainerPC">
                      {message.message}
                      <div className="chatDate">
                        {new Date(message.created_at).toLocaleTimeString(
                          locale,
                          dateOptions,
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="messageContainer">
                    <div
                      onClick={() => {
                        if (message.message_type === "tracker_alert") {
                          if (openBoxMsg === -1) {
                            showBoxMsg(index);
                          } else {
                            showBoxMsg(-1);
                          }
                        }
                      }}
                      className="userMessageContainerPc pointer"
                    >
                      {message.message}
                      <div className="chatDate">
                        {new Date(message.created_at).toLocaleTimeString(
                          locale,
                          dateOptions,
                        )}
                      </div>
                      {index === openBoxMsg ? (
                        <div className="msgBox">
                          <div className="rowMsgBox">
                            <div className="icon5-copy_allMsgBox " />
                            <div>کپی</div>
                          </div>
                          <div
                            onClick={() => {
                              navigateToMap(
                                dataChatFilter?.chat?.tracker_imei.toString(),
                                message.meta?.longitude,
                                message.meta?.latitude,
                              );
                            }}
                            className="rowMsgBox"
                          >
                            <div className="icon3-mapMsgBox" />
                            <div>نمایش روی نقشه</div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="messageIconContainerPc">
                      <div
                        className={`${findIconChat(
                          message.message_type,
                        )} chatItemIconsPc`}
                      />
                    </div>
                  </div>
                )}
              </Fragment>
            ))}
          </div>

          <div
            style={{
              pointerEvents: isLoadingSendMessage ? "none" : "initial",
            }}
            className="chatInputContainer"
          >
            {!showInput ? (
              <>
                <div className="backToChats pointer" onClick={backToChats}>
                  بازگشت به چت ها
                </div>
                <div
                  onClick={
                    dataAllChat?.chat?.tracker_imei
                      ? openCustomCommandModal
                      : showingInput
                  }
                  className="chatSendIconContainer pointer"
                >
                  <div className="icon5-maps_ugc chatSendIcon" />
                </div>
              </>
            ) : (
              <>
                <div className="chatInputWrapper">
                  <div
                    onClick={sendMessage}
                    className="icon5-send sendMessageIcon pointer"
                  />
                  <div
                    contentEditable="true"
                    className="chatInput scrollbar-div"
                    onInput={(e: any) =>
                      handleTxtChange(e.currentTarget.textContent)
                    }
                  />
                </div>
                <div
                  className="icon3-close chatCloseIcon pointer"
                  onClick={hideInput}
                />
              </>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <CustomCommandModal
          imei={dataAllChat?.chat?.tracker_imei}
          command={""}
          statusCommand={""}
          sendSms={sendSms}
          onClose={closeCustomCommandModal}
          open={isCustomCommandModalOpen}
          online={isOnline}
        />
        <div className="chatBg">
          <div className="rowCloseDrawerPc">
            <div onClick={closeDrawer} className="icon3-close pointer" />
            <div
              onClick={changeShowFilter}
              className="chatHeaderFilter pointer"
            >
              <div>فیلتر کردن پیام ها</div>
              <div className="icon3-filter_alt chatHeaderIcon" />
            </div>
          </div>
          <div className="chatHeader">
            <div onClick={submitBeforeMsg} className="beforeMessage pointer">
              مشاهده پیام های قبل
            </div>
          </div>

          <div className="chatMessageScrollPc scrollbar-div">
            {dataAllChat?.messages?.map((message: any, index: number) => (
              <Fragment key={message.id}>
                {message.message_type === "user_support" ? (
                  <div className="messageContainer">
                    <div className="messageIconContainerPc">
                      <div
                        className={`${findIconChat(
                          message.message_type,
                        )} chatItemIconsPc`}
                      />
                    </div>
                    <div className="myMessageContainerPC">
                      {message.message}
                      <div className="chatDate">
                        {new Date(message.created_at).toLocaleTimeString(
                          locale,
                          dateOptions,
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="messageContainer">
                    <div
                      onClick={() => {
                        if (message.message_type === "tracker_alert") {
                          if (openBoxMsg === -1) {
                            showBoxMsg(index);
                          } else {
                            showBoxMsg(-1);
                          }
                        }
                      }}
                      className="userMessageContainerPc pointer"
                    >
                      {message.message}
                      <div className="chatDate">
                        {new Date(message.created_at).toLocaleTimeString(
                          locale,
                          dateOptions,
                        )}
                      </div>
                      {index === openBoxMsg ? (
                        <div className="msgBox">
                          <div
                            onClick={() => copyText(message.message)}
                            className="rowMsgBox"
                          >
                            <div className="icon5-copy_allMsgBox " />
                            <div>کپی</div>
                          </div>
                          <div
                            onClick={() => {
                              navigateToMap(
                                dataAllChat?.chat?.tracker_imei.toString(),
                                message?.meta?.longitude,
                                message?.meta?.latitude,
                              );
                            }}
                            className="rowMsgBox"
                          >
                            <div className="icon3-mapMsgBox" />
                            <div>نمایش روی نقشه</div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="messageIconContainerPc">
                      <div
                        className={`${findIconChat(
                          message.message_type,
                        )} chatItemIconsPc`}
                      />
                    </div>
                  </div>
                )}
              </Fragment>
            ))}
          </div>

          <div
            style={{
              pointerEvents: isLoadingSendMessage ? "none" : "initial",
            }}
            className="chatInputContainer"
          >
            {!showInput ? (
              <>
                <div className="backToChats pointer" onClick={backToChats}>
                  بازگشت به چت ها
                </div>
                <div
                  onClick={
                    dataAllChat?.chat?.tracker_imei
                      ? openCustomCommandModal
                      : showingInput
                  }
                  className="chatSendIconContainer pointer"
                >
                  <div className="icon5-maps_ugc chatSendIcon" />
                </div>
              </>
            ) : (
              <>
                <div className="chatInputWrapper">
                  <div
                    onClick={sendMessage}
                    className="icon5-send sendMessageIcon pointer"
                  />
                  <div
                    contentEditable="true"
                    className="chatInput scrollbar-div"
                    onInput={(e: any) =>
                      handleTxtChange(e.currentTarget.textContent)
                    }
                  />
                </div>
                <div
                  className="icon3-close chatCloseIcon pointer"
                  onClick={hideInput}
                />
              </>
            )}
          </div>
        </div>
      </>
    );
  }
};

export default ChatPc;
